exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".box[data-v-0b800442]{background-color:#f5f7fa;height:100%;overflow-y:scroll}.content-box[data-v-0b800442]{width:1150px;margin-right:auto;margin-left:auto;margin-top:19px}", "", {"version":3,"sources":["D:/pr/教育培训prod-PC/src/pages/webMall/index/index.vue"],"names":[],"mappings":"AACA,sBACE,yBAA0B,AAC1B,YAAa,AACb,iBAAmB,CACpB,AACD,8BACE,aAAe,AACf,kBAAmB,AACnB,iBAAkB,AAClB,eAAiB,CAClB","file":"index.vue","sourcesContent":["\n.box[data-v-0b800442] {\n  background-color: #f5f7fa;\n  height: 100%;\n  overflow-y: scroll;\n}\n.content-box[data-v-0b800442] {\n  width:  1150px;\n  margin-right: auto;\n  margin-left: auto;\n  margin-top: 19px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b800442","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/webMall/index/index.vue
// module id = 3145
// module chunks = 37